import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import localforage from "localforage";

import { isEmpty } from "@/utils";
import DropDownList from "@/react-components/DropDownList";
import { cookieKeyEnum } from "@/utils/enum";

class SearchBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      keyWord: "",
      historyList: [],
    };
    this.dropDownListRef = React.createRef();
  }

  componentDidMount() {
    const { keyword } = this.props;
    const { keyWord } = this.state;
    if (!isEmpty(keyword) && keyword !== keyWord) {
      this.setState({ keyWord: keyword });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { keyword } = nextProps;
    const { keyWord } = this.state;
    if (!isEmpty(keyword) && keyword !== keyWord) {
      this.setState({ keyWord: keyword });
    }
  }

  fetchHistoryList = () => {
    localforage
      .getItem(cookieKeyEnum.crossHistory)
      .then((value) => {
        this.setState({ historyList: value || [] });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  saveHistory = () => {
    const { keyWord } = this.state;
    if (!isEmpty(keyWord)) {
      localforage
        .getItem(cookieKeyEnum.crossHistory)
        .then((value) => {
          let temp = value ? [...value] : [];
          if (temp.filter((item) => item.text === keyWord).length === 0) {
            temp.unshift({ text: keyWord, value: keyWord });
          }
          if (temp.length > 5) {
            temp = temp.slice(0, 5);
          }
          localforage
            .setItem(cookieKeyEnum.crossHistory, temp)
            .catch((error) => {
              console.error(error);
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  show = () => {
    this.fetchHistoryList();
    setTimeout(() => {
      this.dropDownListRef.current.show();
    }, 200);
  };

  hide = () => {
    this.dropDownListRef.current.hide();
  };

  handleMenuClick = (item, index) => {
    this.setState({ keyWord: item.text }, () => {
      this.searchClick();
    });
  };

  // 「Enter」キーの押下、検索を実行
  onKeyup = (e) => {
    const { keyWord } = this.state;
    if (e.keyCode === 13 && !isEmpty(keyWord)) {
      this.searchClick();
    }
  }

  searchClick = () => {
    const { search } = this.props;
    const { keyWord } = this.state;
    this.hide();
    this.saveHistory();
    search && search(keyWord);
  };

  onChange = (e) => {
    this.setState({
      keyWord: e.target.value,
    });
  };

  render() {
    const { keyWord, historyList } = this.state;
    let resultList = historyList;
    if (!isEmpty(keyWord)) {
      resultList = historyList.filter(
        (item) => item.text.indexOf(keyWord) !== -1
      );
    }

    return (
      <div className="flex-row-vertical-center search-bar">
        <img
          className="search-bar-icon"
          src={require("@/assets/images/search-lends.svg")}
          alt=""
        />
        <input
          id="search-bar-input"
          className="search-bar-input"
          type="text"
          value={keyWord}
          maxLength="50"
          onFocus={this.show}
          onChange={this.onChange}
          placeholder={this.props.t("TCMS01002_placeholder")}
          autoComplete="off"
          onKeyUp={this.onKeyup}
        />
        <button
          disabled={isEmpty(keyWord)}
          className="search-bar-button"
          onClick={this.searchClick}
        >
          {this.props.t("TCMS01002_searchBtn")}
        </button>
        <DropDownList
          ref={this.dropDownListRef}
          list={resultList}
          onChange={this.handleMenuClick}
          className="search-bar-drop-down-container"
        />
      </div>
    );
  }
}

SearchBar.propTypes = {
  search: PropTypes.func,
  keyword: PropTypes.string,
};

SearchBar.defaultProps = {
  search: undefined,
  keyword: "",
};

export default withTranslation()(SearchBar);
